// frontend/components/events/EventPictures.tsx

'use client'

import { useState } from 'react';
import { Button, Card, Modal, Spinner } from 'flowbite-react';
// import Image from 'next/image'; 
import type { EventImage } from '../../models';

// --- Type Definitions for Props ---
interface Props {
    images: EventImage[];
    canManage?: boolean;
    onAddPictures?: () => void;
    // The onDelete callback can now be async to allow the parent to handle it.
    onDelete?: (imageId: string) => Promise<void> | undefined;
}

const EventPictures: React.FC<Props> = ({
    images = [],
    canManage = false,
    onAddPictures,
    onDelete,
}) => {
    // State to hold the image being viewed in the modal.
    const [imageToView, setImageToView] = useState<EventImage | null>(null);
    // NEW: State to track the ID of the image currently being deleted.
    const [deletingImageId, setDeletingImageId] = useState<string | null>(null);

    // NEW: Wrapper function for the delete handler to manage loading state.
    const handleDeleteClick = async (imageId: string) => {
        if (!onDelete) return;

        setDeletingImageId(imageId);
        try {
            await onDelete(imageId);
        } catch (error) {
            // The parent component should handle error notifications (e.g., toast).
            console.error("Deletion failed from parent:", error);
        } finally {
            // Reset the loading state regardless of success or failure.
            setDeletingImageId(null);
        }
    };

    return (
        <div className='mt-6 pt-12 sm:pr-24 sm:pl-24'>
            {canManage && onAddPictures && (
                <div className="mb-8 flex items-center justify-center">
                    <Button onClick={onAddPictures}>
                        Add Pictures
                    </Button>
                </div>
            )}

            {images.length > 0 ? (
                <ul
                    role="list"
                    className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5"
                >
                    {images.map((image) => (
                        <li key={image.id} className="relative">
                            <Card className="max-w-sm" theme={{ root: { children: 'p-0' }}}>
                                {/* The parent div MUST have position: relative and defined dimensions */}
                                <div className="relative h-40 w-full cursor-pointer" onClick={() => setImageToView(image)}>
                                    {/* UPDATED: Using modern next/image props */}
                                    <img
                                        src={image.link as string}
                                        alt="Event Image"
                                        // fill // Replaces layout="fill"
                                        className="rounded-t-lg object-cover" // Replaces objectFit="cover"
                                        sizes="(max-width: 640px) 50vw, (max-width: 1024px) 33vw, 20vw" // Helps with performance
                                    />
                                </div>
                                <div className="flex items-center justify-between p-4">
                                    <Button size="xs" onClick={() => setImageToView(image)}>
                                        View
                                    </Button>

                                    {/* {canManage && onDelete && (
                                        <Button
                                            size="xs"
                                            color="red"
                                            onClick={() => handleDeleteClick(image.id)}
                                            disabled={deletingImageId === image.id}
                                            aria-label={`Delete image ${image.id}`}
                                        >
                                            {deletingImageId === image.id ? (
                                                <Spinner size="sm" />
                                            ) : (
                                                'Delete'
                                            )}
                                        </Button>
                                    )} */}
                                </div>
                            </Card>
                        </li>
                    ))}
                </ul>
            ) : (
                <p className="text-center text-gray-500">No images have been added to this event yet.</p>
            )}

            <Modal show={!!imageToView} size="3xl" onClose={() => setImageToView(null)} dismissible>
                <Modal.Header>Image Preview</Modal.Header>
                <Modal.Body>
                    <div className="relative mx-auto h-[70vh] w-full">
                         {/* UPDATED: Using modern next/image props in the modal as well */}
                        <img
                            src={imageToView?.link || '/placeholder.png'}
                            alt="Event full view"
                            // fill // Replaces layout="fill"
                            className="object-contain" // Replaces objectFit="contain"
                            sizes="100vw"
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button color="gray" onClick={() => setImageToView(null)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default EventPictures;